export var get = function get(object, fieldName, defaultValue) {
  if (object && object.hasOwnProperty(fieldName)) {
    return object[fieldName];
  }

  if (defaultValue === undefined) {
    throw new Error("Required arg \"".concat(fieldName, "\" was not provided"));
  }

  return defaultValue;
};
export var switcher = function switcher(description) {
  return function (key) {
    description[key] && description[key]();
  };
};